import React, { useState, useEffect } from 'react';
import { getOrganizations } from '../../../api';
import OrganizationDropdown from './OrganizationDropdown';
import { updateTabTitle } from '../../../utils/tabTitle';


function OrganizationsList({
  user,
  navigate,
  onClose,
  submenuItemStyles,
  onOpenOrganizationManagement,
  onOpenMembersManagement,
  onViewOrganizationLeads,
  isInHamburgerMenu = false
}) {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrgId, setSelectedOrgId] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ x: 0, y: 0 });

  // Organisationen laden
  useEffect(() => {
    const loadOrganizations = async () => {
      if (!user?.id) return;
      
      setLoading(true);
      try {
        const response = await getOrganizations(user.id);
        if (response.success) {
          setOrganizations(response.organizations || []);
        } else {
          console.error('Fehler beim Laden der Organisationen:', response.error);
        }
      } catch (error) {
        console.error('Fehler beim Laden der Organisationen:', error);
      } finally {
        setLoading(false);
      }
    };

    loadOrganizations();
  }, [user?.id]);

  // Dropdown außerhalb schließen
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showDropdown && !event.target.closest('.organizations-list-container')) {
        setShowDropdown(false);
        setSelectedOrgId(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown]);

  const handleOrganizationClick = (event, orgId) => {
    event.preventDefault();
    event.stopPropagation();
    
    if (isInHamburgerMenu) {
      // Im HamburgerMenu: Dropdown direkt unter dem Element positionieren
      const rect = event.currentTarget.getBoundingClientRect();
      setDropdownPosition({
        x: rect.left,
        y: rect.bottom + 5
      });
    } else {
      // In Desktop-Navigation: Dropdown rechts neben dem Element positionieren
      const rect = event.currentTarget.getBoundingClientRect();
      setDropdownPosition({
        x: rect.right + 5,
        y: rect.top
      });
    }
    
    setSelectedOrgId(orgId);
    setShowDropdown(true);
    
    // Tab-Titel basierend auf der ausgewählten Organisation aktualisieren
    updateTabTitle(orgId);
  };

  const handleDropdownClose = () => {
    setShowDropdown(false);
    setSelectedOrgId(null);
  };

  const containerStyle = {
    position: 'relative',
    display: 'inline-block',
    width: '100%'
  };

  const organizationItemStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '8px 16px',
    textAlign: 'left',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#4a5568',
    transition: 'background-color 0.2s',
    minWidth: '200px'
  };

  const dropdownContainerStyle = {
    position: isInHamburgerMenu ? 'absolute' : 'fixed',
    top: dropdownPosition.y,
    left: dropdownPosition.x,
    backgroundColor: 'white',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    zIndex: '1000',
    minWidth: '200px'
  };

  if (loading) {
    return (
      <div style={organizationItemStyle}>
        <span>Lade Organisationen...</span>
      </div>
    );
  }

  if (organizations.length === 0) {
    return (
      <div style={organizationItemStyle}>
        <span>Keine Organisationen verfügbar</span>
      </div>
    );
  }

  return (
    <div className="organizations-list-container" style={containerStyle}>
      {organizations.map((org) => (
        <button
          key={org.id}
          style={organizationItemStyle}
          className={`${org.id === 6 ? 'dropdown-item-org-6' : ''}`}
          onClick={(e) => handleOrganizationClick(e, org.id)}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
        >
          <span>🏢 {org.name}</span>
          <svg 
            width="12" 
            height="12" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <polyline points="6,9 12,15 18,9"></polyline>
          </svg>
        </button>
      ))}

      {/* Dropdown für ausgewählte Organisation */}
      {showDropdown && selectedOrgId && (
        <div style={dropdownContainerStyle}>
          <OrganizationDropdown
            user={user}
            navigate={navigate}
            onClose={handleDropdownClose}
            submenuItemStyles={submenuItemStyles}
            selectedOrgId={selectedOrgId}
            onOpenOrganizationManagement={onOpenOrganizationManagement}
            onOpenMembersManagement={onOpenMembersManagement}
            onViewOrganizationLeads={onViewOrganizationLeads}
          />
        </div>
      )}
    </div>
  );
}

export default OrganizationsList; 